import { Injectable } from '@angular/core';
import { BaseTableStateService } from 'src/app/services/base-table-state.service';

export interface UsersFilters {
  companyID: number | null;
  domainID: number | null;
  journeyID: number | null;
}

@Injectable({ providedIn: 'root' })
export class JourneyBuilderTableStateService extends BaseTableStateService<UsersFilters> {
  protected getDefaultFilters(): UsersFilters {
    return {
      companyID: null,
      domainID: null,
      journeyID: null,
    };
  }
}
